import styled from 'styled-components'

import type { TooltipIconProps } from './types'

export const TooltipIcon = styled.span<TooltipIconProps>`
  background-image: url(${({ iconSvg }) => iconSvg});
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  background-size: 15px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  display: inline-block;
  margin-left: 4px;
  transform: translateY(3px);
`
